import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Smart from "../Allcomponent/smart"
import Accessories from "../Allcomponent/accsseroies"
import Laptop from "../Allcomponent/laptop"
import Tablet from "../Allcomponent/tablet"
import Sunglasses from "../Allcomponent/sunglasses"
function Home (){
    return(
        <>
        <Banner/>
        <Cards/>
        <Smart/>
        <Accessories/>
        <Laptop/>
        <Tablet/>
        <Sunglasses/>
        </>
    )
}
export default Home